<template>
    <div class="mobile-container">
        <!-- 头部导航 -->
        <div class="header">
            <div class="header-title">{{ title }}</div>
        </div>

        <!-- 表单内容 -->
        <div class="form-content">
            <div class="mobile-form">
                <div class="form-item">
                    <label class="form-label">团组描述：</label>
                    <div class="form-input">{{ manageMentInfo.teamDesc }}</div>
                </div>

                <div class="form-item">
                    <label class="form-label">申请单位：</label>
                    <div class="form-input">{{ manageMentInfo.companyName }}</div>
                </div>

                <div class="form-item">
                    <label class="form-label">团长：</label>
                    <div class="form-input">{{ manageMentInfo.leaderName }}</div>
                </div>

                <div class="form-item">
                    <label class="form-label">人数：</label>
                    <div class="form-input">{{ manageMentInfo.num }}</div>
                </div>

                <div class="form-item" v-if="type == 2">
                    <label class="form-label">国家(地区)：</label>
                    <div class="form-input" style="border: none">
                        {{ manageMentInfo.visitCountry }}
                    </div>
                </div>

                <div class="form-item" v-if="type == 2">
                    <label class="form-label">任务类别：</label>
                    <div class="form-input">{{ manageMentInfo.taskTypeName }}</div>
                </div>

                <div class="form-item" v-if="type == 2">
                    <label class="form-label">签发使/领馆：</label>
                    <div class="form-input">{{ manageMentInfo.consulates }}</div>
                </div>

                <div class="form-item" v-if="type == 2">
                    <label class="form-label">办理方式：</label>
                    <div class="form-input">{{ manageMentInfo.type | formatType }}</div>
                </div>

                <div class="form-item" v-if="type == 2">
                    <label class="form-label">申办原因：</label>
                    <div class="form-input">
                        {{ manageMentInfo.reasonType | formatReasonType }}
                    </div>
                </div>

                <div class="form-item" v-if="type == 2">
                    <label class="form-label">其他原因说明：</label>
                    <div class="form-input">{{ manageMentInfo.otherReason }}</div>
                </div>
            </div>
            <div class="table">
                <div class="header" style="margin: 2px 0; height: 30px">
                    <div class="header-title">人员名单</div>
                </div>
                <el-table :data="list" border v-if="list.length">
                    <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                    <el-table-column label="出生年月" prop="birthday" v-if="type == 2"></el-table-column>

                    <el-table-column label="性别" prop="sex" v-if="type == 3" :formatter="formatSex"></el-table-column>
                    <el-table-column label="证照号码" prop="passportNo"></el-table-column>
                    <el-table-column label="有效期至" prop="validityDate"></el-table-column>
                    <el-table-column label="办理原因" prop="reason"></el-table-column>
                    <el-table-column label="证照扫描件" v-if="type == 2">
                        <template slot-scope="props">
                            <div>
                                <span v-if="!props.row.oldScan">无</span>
                                <el-button v-else type="text">
                                    <a
                                        v-if="props.row.oldScan"
                                        target="_blank"
                                        :href="`/share-foreign/commannex/viewAnnex?path=${props.row.oldScan}&token=${token}`"
                                        >查看</a
                                    >
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="form-item">
                <label class="form-label">请示文件：</label>
                <div class="form-input" style="border: none">
                    <span class="file-name" style="margin-right: 16px" v-if="manageMentInfo.askFile">{{ manageMentInfo.askFile | formateFile }}</span>
                    <span class="file-name" v-else>无</span>

                    <span class="preview-btn" @click="handlePreviewFile(manageMentInfo.askFile)" v-if="manageMentInfo.askFile">预览</span>
                </div>
            </div>

            <div class="form-item">
                <label class="form-label">其他附件：</label>
                <div class="form-input" style="border: none">
                    <span class="file-name" style="margin-right: 16px" v-if="manageMentInfo.otherFile">{{
                        manageMentInfo.otherFile | formateFile
                    }}</span>
                    <span class="file-name" v-else>无</span>

                    <span class="preview-btn" @click="handlePreviewFile(manageMentInfo.otherFile)" v-if="manageMentInfo.otherFile">预览</span>
                </div>
            </div>
        </div>

        <!-- 底部按钮 -->
        <div class="footer-buttons">
            <el-button class="btn-disagree" @click="approvalHandler('N')" size="mini" type="danger">不同意</el-button>
            <el-button class="btn-agree" @click="approvalHandler('Y')" size="mini" type="primary">同意</el-button>
        </div>
        <MessageBox ref="messageBox" @approve="handleApprove" @reject="handleReject" />
    </div>
</template>

<script>
import MobileApi from "@/api/mobile"
import { mapGetters } from "vuex"
import MessageBox from "./messageBox.vue"
export default {
    name: "mobile",
    components: {
        MessageBox
    },
    data() {
        return {
            Api: new MobileApi(),
            manageMentInfo: {
                teamDesc: "",
                companyName: "",
                num: 0,
                leaderName: "",

                visitCountry: "",

                taskTypeName: "",
                consulates: "",
                consulates: "",
                type: "",
                reasonType: "",
                askFile: "",
                otherFile: "",
                receiveNo: "",

                otherReason: ""
            },
            list: []
        }
    },
    props: {
        type: {
            type: String,
            default: ""
        },
        missiveId: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        }
    },
    filters: {
        formatType(type) {
            return type == 1 ? "换发护照" : type == 2 ? "补发护照" : type == 3 ? "申请旅行证" : ""
        },
        formatReasonType(reasonType) {
            return reasonType == 1 ? "失效" : reasonType == 2 ? "丢失" : reasonType == 3 ? "损毁" : reasonType == 5 ? "其他" : ""
        },
        formateFile(path) {
            if (path && /annex\/\d+_(.*)/.test(path)) {
                return path.match(/annex\/\d+_(.*)/)[1]
            }
            return path
        }
    },
    computed: {
        ...mapGetters(["token"])
    },

    mounted() {
        this.getInfo()
    },
    methods: {
        formatSex(row, column, cellValue) {
            console.log(cellValue)
            if (cellValue == "M") {
                return "女"
            } else {
                return "男"
            }
        },
        handlePreviewFile(filePath) {
            console.log(filePath)
            let fileName = filePath.split("/").pop()

            let src = `/share-foreign/commannex/viewAnnex?path=${filePath}&token=${this.token}`
            if (fileName.match(/\.pdf$/) || fileName.match(/\.PDF$/)) {
                window.open(src)
            } else {
                this.$message("仅支持pdf类型文件的预览")
            }
        },
        getInfo() {
            if (this.type == 2) {
                this.Api.getDetailTwo({
                    renewalId: this.missiveId
                }).then(res => {
                    for (let key in this.manageMentInfo) {
                        this.manageMentInfo[key] = res.data.renewalPassportRsult[key]
                    }
                    this.list = res.data.list
                })
            } else if (this.type == 3) {
                this.Api.destoryDetail({
                    destroyId: this.missiveId
                }).then(res => {
                    for (let key in this.manageMentInfo) {
                        this.manageMentInfo[key] = res.data.destroyPassport[key]
                    }
                    this.list = res.data.users || []
                    console.log(this.list, "this.list")
                })
            }
        },
        ////审批 同意or不同意
        approvalHandler(agree) {
            //换发
            if (agree == "Y") {
                this.$refs.messageBox.showConfirm({
                    title: "提示",
                    message: "是否确认同意审批？"
                })
            } else if (agree == "N") {
                this.$refs.messageBox.showInput({
                    title: "请输入审批意见",
                    placeholder: ""
                })
            }
        },

        // 处理同意操作
        handleApprove() {
            console.log("执行1")

            this.submitTask("", "Y")

            // 这里可以调用API提交审批结果
        },

        // 处理不同意操作
        handleReject(reason) {
            this.submitTask(reason, "N")

            // 这里可以调用API提交审批结果
        },
        submitTask(value, agree) {
            if (this.type == 2) {
                this.Api.submitTask({
                    renewalId: this.missiveId,
                    opinion: value,
                    agree
                }).then(res => {
                    console.log(res, "掉接口了1")
                    this.$emit("submit")
                    this.$message.success(res.msg)
                })
            } else if (this.type == 3) {
                this.Api.submitTaskDestroy({
                    destroyId: this.missiveId,
                    opinion: value,
                    agree
                }).then(res => {
                    console.log(res, "掉接口了2")
                    this.$emit("submit")
                    this.$message.success(res.msg)
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-container {
    min-height: 100vh;

    display: flex;
    flex-direction: column;
    height: 100vh; // 设置固定高度
    overflow: hidden; // 防止整体滚动
}

.header {
    background-color: #9fd3f6;
    height: 40px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 100;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding-left: 20px;
    flex-shrink: 0; // 防止头部被压缩

    .header-title {
        color: #000;
        font-size: 18px;
    }
}

.form-content {
    flex: 1;
    padding-bottom: 80px;
    overflow-y: auto; // 允许垂直滚动
    overflow-x: hidden; // 隐藏水平滚动
    -webkit-overflow-scrolling: touch; // iOS 平滑滚动
}

.mobile-form {
    border-radius: 8px;
}

.form-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;
    min-height: 40px; // 确保每行有最小高度

    &:last-child {
        margin-bottom: 0;
    }

    .form-label {
        width: 90px; // 固定宽度而不是最小宽度
        font-size: 14px;
        color: #333;
        font-weight: 500;
        line-height: 40px; // 与input高度一致
        margin-right: 4px;
        flex-shrink: 0;
        text-align: right;
    }

    .form-input {
        flex: 1;

        border: 1px solid #e9ecef;
        color: #495057;
        font-size: 14px;
        border-radius: 4px;
        padding: 10px 15px;
        line-height: 1.5;
        min-height: 20px;
        word-wrap: break-word;
        display: flex;
        align-items: center;

        &.content-box {
            min-height: 120px;
            white-space: pre-wrap;
            align-items: flex-start;
            padding-top: 10px;
        }

        .file-name {
            color: #333;
            font-size: 14px;
            margin-right: 10px;
        }

        .preview-btn {
            color: #4a90e2;
            font-size: 14px;
            cursor: pointer;
            text-decoration: none;

            &:hover {
                color: #357abd;
                text-decoration: underline;
            }
        }
    }
}

.footer-buttons {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 15px;
    background-color: #fff;

    display: flex;
    gap: 10px;
    z-index: 999;
    justify-content: center;
    .el-button {
        width: 80px;
        height: 40px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 6px;
        border: none;
    }
}

// // 移动端响应式
@media (max-width: 768px) {
    .form-content {
        padding: 10px;
        padding-bottom: 60px;
    }

    .form-item {
        margin-bottom: 12px;
        min-height: 36px;

        .form-label {
            width: 95px;
            font-size: 13px;
            line-height: 36px;
            margin-right: 4px;
        }

        .form-input {
            font-size: 13px;
            padding: 8px 12px;

            &.content-box {
                min-height: 100px;
                padding-top: 8px;
            }
        }
    }

    .footer-buttons {
        padding: 12px;
        display: flex;
        display: flex;
        justify-content: center;

        .el-button {
            flex-grow: 0;
            width: 80px;
            height: 36px;
            font-size: 14px;
        }
    }

    .header {
        padding-left: 20px;

        .header-title {
            font-size: 16px;
        }
    }
}
</style>
